import { TemperatureTypes } from "@/store/modules/user/types";

export const c2Requested = (value: number, requested: TemperatureTypes) => {
  if (requested === "C") {
    return value;
  } else {
    return value * 1.8 + 32;
  }
};

export const c2RequestedGraph = (graphs: any, requested: TemperatureTypes) => {
  const newGraphs = graphs.map((g: any) => {
    g.data = g.data.map((d: any) => {
      const newData = { x: d.x, y: 0 };
      newData.y = c2Requested(d.y, requested);
      return newData;
    });
    return g;
  });

  return newGraphs;
};
